import { useCustom } from '@refinedev/core';
import { Spin } from 'antd';
import { Key } from 'lucide-react';
import { useState, type FC } from 'react';
import { useParams } from 'react-router-dom';

import ByokStatusCard from '@/components/ops/ByokStatusCard';
import EnableByokModal from '@/components/ops/EnableByokModal';

export interface ByokStatus {
  enabled: boolean;
  maskedKey: string | null;
  provider: string | null;
  enabledAt: string | null;
}

const ByokManagerPage: FC = () => {
  const { id: orgId } = useParams<{ id: string }>();
  const [modalOpen, setModalOpen] = useState(false);

  const { data, isLoading, isError, refetch } = useCustom<{ data: ByokStatus }>({
    url: `/api/v1/admin/subscription/organizations/${orgId}/byok/status`,
    method: 'get',
    queryOptions: { enabled: !!orgId },
  });

  const status = data?.data?.data;

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <GradientHeader />

      {isError ? (
        <div className="fc-card border-red-300 p-6 dark:border-red-800">
          <p className="font-medium text-red-600 dark:text-red-400">
            Impossible de charger le statut BYOK pour cette organisation.
          </p>
        </div>
      ) : (
        <ByokStatusCard
          status={status}
          orgId={orgId!}
          onEnableClick={() => setModalOpen(true)}
          onDisableSuccess={() => void refetch()}
        />
      )}

      <EnableByokModal
        open={modalOpen}
        orgId={orgId!}
        onClose={() => setModalOpen(false)}
        onSuccess={() => { setModalOpen(false); void refetch(); }}
      />
    </div>
  );
};

const GradientHeader: FC = () => (
  <div className="fc-gradient-header rounded-2xl p-6 text-white">
    <div className="flex items-center gap-3">
      <Key className="h-6 w-6" />
      <div>
        <h1 className="text-xl font-bold">BYOK Manager</h1>
        <p className="mt-1 text-sm text-blue-100">Configuration Clés API Enterprise</p>
      </div>
    </div>
  </div>
);

export default ByokManagerPage;
